import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { updateKanbanFilter, resetKanbanFilter } from '../actions';
import { selectKanbanFilter } from '../selectors';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { parseCompany } from '../../Companies/helpers';
import { companySearch } from '../../Companies/actions';
import { REQUEST_COMPANIES_SEARCH } from '../../Companies/constants';
import { changeUserFilter } from '../../Users/actions';
import { REQUEST_USERS } from '../../Users/constants';
import { selectUsers } from '../../Users/selectors';
import { selectWork, selectWorks } from '../../Api/selectors';
import { Loader } from '../../../components/Loader';
import { MultiSelectDropdown } from '../../../components/Multiselect';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import dayjs from 'dayjs';
import { IconRightDecorator } from '../../../components/Icon/IconRightDecorator';
import { Calendar } from '../../../components/Icon';
import DatePicker from 'react-datepicker';
import cn from 'classnames';
import styles from './KanbanFilter.module.css';

const Container = styled.div`
  .ranged {
  }
`;
const DropdownContainer = styled.div`
  position: relative;
`;
const DropdownOptions = styled.ul`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  top: 50px;
  left: 0;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '5px' : '0')};
  margin-top: 20px;
  background-color: white;
  max-height: 200px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#dee2e6' : 'white')};
  color: ${({ isSelected }) => (isSelected ? '#6c757d' : '#6c757d')};

  &:hover {
    background-color: #86b6fe3b;
    color: #6c757d;
  }
`;

const STATE = {
  selectedOption: null,
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  showOptions: false,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
  selectedMin: null,
  selectedMax: null,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanFilterComp extends BaseComponent {
  constructor(props) {
    let filterPair = props.filter?.properties?.find(f => f.key === props.name);
    let filterValue = filterPair?.value;
    let filterLabel = filterPair?.label;
    let updateState = {};
    if (filterValue) {
      switch (props.type) {
        case 'single':
          updateState = { selectedValue: filterValue[0] ?? null, selectedLabel: filterLabel[0] ?? '' };
          break;
        case 'multiple':
          updateState = { selectedValue: filterValue ?? [], selectedLabel: filterLabel ?? [] };
          break;
      }
    }

    super(props, {
      ...STATE,
      ...updateState,
      search: props.filter?.searchString || '',
      options: props.options ?? [],
    });

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedValue !== this.state.selectedValue) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
        this.reset();
      } else {
        this.props.updateFilter([this.state.selectedValue + ''], [this.state.selectedLabel]);
      }
    }

    if (this.state.selectedMin && this.state.selectedMax) {
      if (prevState.selectedMin !== this.state.selectedMin || prevState.selectedMax !== this.state.selectedMax) {
        this.props.updateFilter(
          [dayjs(this.state.selectedMin).format('YYYY-MM-DD'), dayjs(this.state.selectedMax).format('YYYY-MM-DD')],
          [this.state.selectedLabel],
        );
      }
    }

    if (prevState.text !== this.state.text) {
      if (!this.state.text) {
        this.setState({ showOptions: false, options: [] });
      } else {
        this.setState({
          showOptions: true,
          options: this.props.options?.filter(op => op?.label?.toLowerCase()?.includes(this.state.text)),
        });
      }
    }

    if (!Array.isArray(this.state.selectedOption) && !_.isEqual(prevState.selectedOption, this.state.selectedOption)) {
      if (!this.state.selectedOption) {
        this.props.reset();
        this.reset();
      } else {
        this.props.updateFilter([this.state.selectedOption?.value + ''], [this.state.selectedOption?.label]);
      }
    }

    if (Array.isArray(this.state.selectedOption) && !_.isEqual(prevState.selectedOption, this.state.selectedOption)) {
      if (!this.state.selectedOption?.length) {
        this.props.reset();
      } else {
        const { values, labels } = this.state.selectedOption.reduce(
          (acc, item) => {
            acc.values.push(item.value);
            acc.labels.push(item.label);

            return acc;
          },
          { values: [], labels: [] },
        );
        this.props.updateFilter(values, labels);
      }
    }

    if (!_.isEqual(prevProps.filter?.properties, this.props.filter?.properties)) {
      if (!this.props.filter.properties?.find(p => p.key === this.props.name)) {
        this.setState({ selectedOption: null, selectedValue: null, selectedLabel: '', text: '' });
      }
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  compareLabel = (a, b) => {
    const aLabel = a.label.toLowerCase();
    const bLabel = b.label.toLowerCase();
    if (aLabel < bLabel) {
      return -1;
    }
    if (aLabel > bLabel) {
      return 1;
    }
    return 0;
  };

  searchCompany = () => {
    const searchText = normalizeSearchString(this.state.text);
    if (!searchText) return;
    this.props.searchCompany(this.state.text, result =>
      this.setState({
        showOptions: true,
        options: result?.items
          ?.map(parseCompany)
          ?.map(c => ({
            label: c.company_type === 'company' ? c?.name : `${c?.name}${c?.surname ? ' ' + c?.surname : ''}`,
            value: c?.id + '',
          }))
          ?.sort(this.compareLabel),
      }),
    );
  };

  searchUser = () => {
    const searchText = normalizeSearchString(this.state.text);
    if (!searchText) return;
    this.props.searchUser(this.state.text);
  };

  search = () => {
    if (this.props.search === 'company') {
      this._t = this.timeout(this.searchCompany, 600, this._t);
    }
  };

  selectSearchOption = option => {
    if (this.props.search === 'company') {
      this.setState({
        selectedValue: option?.value,
        selectedLabel: option?.label,
        text: '',
        showOptions: false,
      });
    }
    if (this.props.search === 'user') {
      this.setState({
        selectedValue: option?.value,
        selectedLabel: option?.label,
        text: '',
        showOptions: false,
      });
    }
  };

  onStringChange = evt => {
    let text = evt.target.value;
    if (this.props.search === 'company') {
      this.setState({ text, showOptions: true });
      let debounced = _.debounce(this.search, 300, { maxWait: 1000 });
      debounced();
    }
    if (this.props.search === 'user') {
      console.log('text: ', text);
      const filteredOptions = this.props.options?.filter(o => o?.label?.toLowerCase()?.includes(text?.toLowerCase()));
      this.setState({ text, showOptions: true, options: filteredOptions });
    }
  };

  toggleOption = (val, lbl) => {
    if (this.state.selectedValue === val) {
      this.setState({
        selectedValue: null,
        selectedLabel: '',
      });
    } else {
      this.setState({
        selectedValue: val,
        selectedLabel: lbl,
      });
    }
  };

  toggleViewOptions = val => {
    this.setState({ showOptions: val });
  };

  handleMultiselectSearch = e => {
    let searchText = e.target.value;
    const filteredOptions = !!searchText
      ? this.props.options?.filter(o => o?.label?.toLowerCase()?.includes(searchText?.toLowerCase()))
      : this.props.options;
    this.setState({ text: searchText, showOptions: true, options: [...filteredOptions] });
  };

  handleChange = option => {
    this.setState({ selectedOption: option });
  };
  renderUsersFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value;

    return (
      <>
        <label className="form-label">{label}</label>
        <SearchSelect
          isMulti={this.props.type === 'multiple'}
          options={this.props.options}
          isSearchable
          placeholder={label}
          value={this.state.selectedOption}
          onChange={this.handleChange}
        />
      </>
    );
  };

  renderSingleSearchFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    if (this.props.search === 'company') {
      return (
        <DropdownContainer ref={this.wrapperRef}>
          <label className="form-label">{label}</label>
          <input
            className="form-control"
            name="text"
            onChange={this.onStringChange}
            value={this.state.text}
            placeholder={label}
          />

          {!!this.state.showOptions && this.state.options?.length && (
            <DropdownOptions show={!!this.state.showOptions}>
              {this.state.options?.map((option, idx) => {
                return (
                  <DropdownOption
                    isSelected={option.value === this.state[this.props.search]}
                    key={`${this.props.name}_${option?.value}`}
                    onClick={() => this.selectSearchOption(option)}
                  >
                    <span>{option?.label}</span>
                  </DropdownOption>
                );
              })}
            </DropdownOptions>
          )}
        </DropdownContainer>
      );
    }
    if (this.props.search === 'user') {
      return (
        <DropdownContainer ref={this.wrapperRef}>
          <label className="form-label">{label}</label>
          <input
            className="form-control"
            name="text"
            onChange={this.onStringChange}
            value={this.state.text}
            placeholder={label}
          />
          {!!this.state.showOptions && !!this.state.options?.length && (
            <DropdownOptions show={!!this.state.showOptions}>
              {this.state.options?.map((option, idx) => {
                return (
                  <DropdownOption
                    isSelected={option?.value === this.state.user?.id}
                    key={`${this.props.name}_${option?.value}`}
                    onClick={() => this.selectSearchOption(option)}
                  >
                    <span>{option?.label}</span>
                  </DropdownOption>
                );
              })}
            </DropdownOptions>
          )}
        </DropdownContainer>
      );
    }
  };

  handleClickOutside = e => {
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target) && !!this.state.showOptions) {
      this.setState({ showOptions: false });
    }
  };

  renderRangedDateFilter = () => {
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value;
    let selMin = selected?.length ? selected[0] : null;
    let selMax = selected?.length ? selected[1] : null;
    let formatMin = selMin?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMin = selMin && dayjs(selMin, formatMin);
    let formatMax = selMax?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMax = selMax && dayjs(selMax, formatMax);
    const updateLabels = this.state.selectedLabels;
    return (
      <div
        className="row mt-2 "
        // label={this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`)}
      >
        <div className="col-12 col-md-6 col-lg-3">
          <label className="form-label">Min Date</label>
          <DatePicker
            className={cn('text-muted', styles.dataPicker)}
            dateFormat="yyyy-MM-dd"
            selected={this.state.selectedMin}
            onChange={date => {
              let d = dayjs(date).format('YYYY-MM-DD');
              this.setState({ selectedMin: date, selectedLabels: updateLabels.splice(0, 1, d) });
            }}
          />
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <label className="form-label">Max Date</label>
          <DatePicker
            className={cn('text-muted', styles.dataPicker)}
            dateFormat="yyyy-MM-dd"
            selected={this.state.selectedMax}
            onChange={date => {
              let d = dayjs(date).format('YYYY-MM-DD');
              this.setState({ selectedMax: date, selectedLabels: updateLabels.splice(1, 1, d) });
            }}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <Container>
        {this.props.search === 'user' && this.renderUsersFilter()}
        {this.props.type === 'single' && this.props.search === 'company' && this.renderSingleSearchFilter()}
        {this.props.type === 'ranged_date' && this.props.search === 'vehicle' && this.renderRangedDateFilter()}
      </Container>
    );
  }
}

KanbanFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectKanbanFilter(),
    loadingCompany: selectWork(REQUEST_COMPANIES_SEARCH),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset() {
      dispatch(resetKanbanFilter(ownProps.name));
    },
    updateFilter(value, label = '') {
      dispatch(
        updateKanbanFilter({
          value: value,
          key: ownProps.name,
          label: label,
          type: ownProps.type,
        }),
      );
    },
    searchCompany(text, callback) {
      dispatch(companySearch(text, callback));
    },
    searchUser(text) {
      dispatch(changeUserFilter('searchString', text));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanFilter = compose(withConnect, withRouter, injectIntl)(KanbanFilterComp);
